import { render, staticRenderFns } from "./revDetails.vue?vue&type=template&id=13acd1e2&scoped=true"
import script from "./revDetails.vue?vue&type=script&lang=js"
export * from "./revDetails.vue?vue&type=script&lang=js"
import style0 from "./revDetails.vue?vue&type=style&index=0&id=13acd1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13acd1e2",
  null
  
)

export default component.exports